export default __webpack_public_path__ + "images/icons/chevron-up-desktop-bd2d23b889916beff5eae51cb074707d.svg";